// extracted by mini-css-extract-plugin
export var bold = "_yt-0";